import { jsx as _jsx } from "react/jsx-runtime";
import Swiper from 'react-id-swiper';
export const PageSwiper = ({ children, getSwiper, initialSlide, containerClass, }) => {
    const params = {
        initialSlide,
        slideActiveClass: 'swiper-slide-active',
        slideClass: 'swiper-slide',
        spaceBetween: 40,
        shortSwipes: false,
        longSwipesMs: 0,
        longSwipesRatio: 0.2,
    };
    return (_jsx(Swiper, Object.assign({}, params, { getSwiper: getSwiper, containerClass: containerClass, children: children })));
};
